import React from 'react';
import { KatBox, KatLink, KatRow } from '@amzn/katal-react';
import { renderToString } from 'react-dom/server';
import { CountryCode, getBREnrollUrl, getBRUrl } from '../urls-config';
import { usePNFTranslation } from 'src/common/helpers';

const BR_IMAGE_URL = 'https://m.media-amazon.com/images/G/01/brandregistry/v2/illustrations-final/Homepage_-_Protect_Brand_1.png';

interface BrandRegistryInfoAlertBoxProps {
  domainCountryCode: CountryCode;
}

export const BrandRegistryInfoAlertBox:
React.FC<BrandRegistryInfoAlertBoxProps> = (props: BrandRegistryInfoAlertBoxProps) => {
  const t = usePNFTranslation();
  const {
    domainCountryCode,
  } = props;

  const brInfoHtmlContent = t('public-notice-form-brand-registry-info').replace
  (
    '{brEnrollLink}',
    renderToString(
      <KatLink
        aria-label="Click here to enroll in brand registry"
        href={getBREnrollUrl(domainCountryCode)}
        target="_blank"
      >
        {t('public-notice-form-brand-registry-label')}
      </KatLink>
    )
  ).replace(
    '{brLink}',
    renderToString(
      <KatLink
        aria-label="Click here to visit brand registry"
        href={getBRUrl(domainCountryCode)}
        target="_blank"
      >
        {t('public-notice-form-amazon-brand-registry-label')}
      </KatLink>
    )
  );

  return (
    <KatBox className="br-info-box" variant="azure">
      <KatRow className="br-image">
        <img
          alt={BR_IMAGE_URL}
          src={BR_IMAGE_URL}
        />
      </KatRow>
      <KatRow>
        <h3>{t('public-notice-form-brand-registry-info-header')}</h3>
      </KatRow>
      <KatRow>
        <span dangerouslySetInnerHTML={{ __html: brInfoHtmlContent }} />
      </KatRow>
    </KatBox>
  );
};
